import { useMutation } from "@tanstack/react-query";
import { publishForm } from "../../api/endpoints/fetchTemplates";
import type { Template } from "../../api/endpoints/fetchTemplates";

export function usePublishFormMutation(params: {
  template: Template;
  email: string;
  successTimerRef: React.MutableRefObject<number | null>;
  setShowSuccess: (v: boolean) => void;
  setErrorText: (v: string | null) => void;
  onSaved: (fileId: string) => void;
  onClose?: () => void;
}) {
  const { template, email, successTimerRef, setShowSuccess, setErrorText, onSaved, onClose } = params;

  return useMutation({
    mutationFn: async () => {
      if (!template?.fileId) throw new Error("Missing fileId for publish operation");
      return publishForm(template.id, email, true);
    },
    onMutate: () => {
      if (successTimerRef.current) {
        clearTimeout(successTimerRef.current);
        successTimerRef.current = null;
      }
      setShowSuccess(false);
      setErrorText(null);
    },
    onSuccess: () => {
      setShowSuccess(true);
      if (successTimerRef.current) {
        clearTimeout(successTimerRef.current);
      }
      successTimerRef.current = window.setTimeout(() => {
        setShowSuccess(false);
        if (template?.id) onSaved(template.id);
        if (onClose) onClose();
      }, 2000);
    },
    onError: (err: unknown) => {
      setShowSuccess(false);
      let message = "Failed to publish";
      if (typeof err === "object" && err !== null) {
        const maybeWithResponse = err as { response?: { data?: { message?: string } } };
        const maybeWithMessage = err as { message?: string };
        message = maybeWithResponse.response?.data?.message ?? maybeWithMessage.message ?? message;
      }
      setErrorText(message);
    },
  });
}
